import "./index.css"
import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { obtenerVueloCotizacion } from "../../../ducks/clientesDuck"
import { formatDinero } from "../../../utils/formatDinero"
import { Tooltip } from "@material-ui/core"
import GroupIcon from '@material-ui/icons/Group'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'

const TarjetaVuelos = () => {
    const { idCotizacion, vueloCotizacion } = useSelector(store => store.cliente)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(obtenerVueloCotizacion({ idCotizacion }))
    }, [dispatch, idCotizacion])

    if (idCotizacion === 0)
        return null

    if (vueloCotizacion.length <= 0)
        return null

    return (
        <div className="TarjetaVuelo-root">
            <div className="contenido">
                {
                    vueloCotizacion.map((vuelo, index) =>
                        <div key={index}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <ul style={{ listStyle: 'none', display: "flex", flexFlow: "column", justifyContent: "center", alignItems: "flex-start", padding: "0 0 0 10px" }}>
                                    <li style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                        <Tooltip title="Costo">
                                            <MonetizationOnIcon color="secondary" />
                                        </Tooltip>
                                        {`${formatDinero(vuelo.Costo)}`}
                                    </li>
                                    <li style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                        <Tooltip title="Comision">
                                            <MonetizationOnIcon color="primary" />
                                        </Tooltip>
                                        {formatDinero(vuelo.Comision)}
                                    </li>
                                </ul>
                                <ul style={{ listStyle: 'none', display: "flex", flexFlow: "column", justifyContent: "center", alignItems: "flex-start", padding: "0 0 0 10px" }}>
                                    <li style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                        <Tooltip title="Total">
                                            <GroupIcon color="primary" />
                                        </Tooltip>
                                        {vuelo.Cantidad}
                                    </li>
                                    <li style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                        <Tooltip title="Total">
                                            <MonetizationOnIcon color="secondary" />
                                        </Tooltip>
                                        {formatDinero(vuelo.Total)}
                                    </li>
                                </ul>
                            </div>
                            <div style={{ padding: "20px" }} dangerouslySetInnerHTML={{ __html: `${vuelo.Vuelo}` }} />
                        </div>
                    )
                }
            </div>
        </div>
    )
}
export default TarjetaVuelos